import { computed, makeObservable, observable } from "mobx"
import ActivityPedaInstance from "./ActivityPedaInstance"
import { TYPES } from "./ActivitiesConverter"
import ActivityResult from "./ActivityResult"




export class QRL extends ActivityPedaInstance {
  ID
  Type = TYPES.QRL
  Text = null
  media = null

  /** @type {Array<Choice>} */
  choices = []

  /** @type {Array<Choice>} */
  clues = []
  currentClueIndex = -1



  Duration = null

  userInput = ""

  constructor(row) {
    super()
    Object.assign(this, row)
  }

  get userClues() {
    return this.clues.slice(0, this.currentClueIndex + 1)
  }

  getNextClue() {
    if(this.currentClueIndex === this.clues.length - 1) return false

    this.currentClueIndex += 1
    return this.clues[this.currentClueIndex]
  }

   localCorrect() {
    if(!this.userInput) return


    let answer = this.userInput.trim().toLowerCase()

    let correctAnswer = this.choices.find(c => {
      let choice_text = c.Text.trim().toLowerCase()
      return choice_text === answer
    })

    let result = new ActivityResult()
    result.is_correct = correctAnswer !== undefined

    let score = result.is_correct ? 1 : 0
    let nb_indices_asked = this.currentClueIndex + 1
    if(nb_indices_asked > 0) {
      let nb_total_indices = this.clues.length
      let coef = 1 - (nb_indices_asked / (nb_total_indices + 1)) // +1 pour quand meme gagner un peu si on a vu tous les indices
      score *= coef
    }

    result.normalized_score = score
    // if(correctAnswer) {
    //   // on renvoie le text du Choice qui a matché, c'est pas forcément le premier
    //   result.additionalInfos = { correctWord: correctAnswer.Text }
    // }
    // else {
      // ici on renvoie le premier mot valide pour l'aficher au joueur
      result.additionalInfos = { correctWord: this.choices[0].Text }
    // }
    this.setResult(result)
  }

   addChoice(json) {
    this.choices.push(json)
  }
   addClue(json) {
    this.clues.push(json)
  }

  getState() {
    let state = super.getState()
    state.userInput = this.userInput
    state.currentClueIndex = this.currentClueIndex
    return state
  }
  setState(state) {
    super.setState(state)
    this.userInput = state.userInput
    this.currentClueIndex = state.currentClueIndex

  }

  observe() {
    super.observe()
    makeObservable(this, {
      userInput: observable,
      currentClueIndex: observable,
      userClues: computed
    })
  }
}


export class QRLFile {
 /** @type {Array<QRL>} */
  all = []

  constructor(json, file) {
    let current = null

    json
    .filter(row => !!row.ID)
    .forEach(row => {
      try {
        if(row.Type === "qrl") {
          current = new QRL(row)
          this.all.push(current)
        }

        if(row.Type === "choice") {
          current.addChoice(row)
        }
        if(row.Type === "clue") {
          current.addClue(row)
        }

        if(row.Type === "debrief") {
          current.addDebrief(row, true)
        }

        if(row.Type === "debrief_correct") {
          current.addDebrief(row, true)
        }
        if(row.Type === "debrief_incorrect") {
          current.addDebrief(row, false)
        }
      }
      catch(err) {
        console.log("err", err)
        throw "ERREUR CREATION QRL : " + row.ID + " dans " + file
      }
    })

    console.log("QRLs", this.all)

  }
  get(id) {
    return this.all.find(qrl => qrl.ID === id)
  }



  observeAll() {
    this.all.forEach(qrl => {
      qrl.observe()
    })
  }
}
